import { TApplicationState } from '../../types/redux';

export const selectFlightEnabled = (state: TApplicationState) => state.meta.flightEnabled;
